export default __webpack_public_path__ + "static/media/lock.d4328791.svg";